import { render } from "./MainThietBi.vue?vue&type=template&id=42d07a90&scoped=true"
import script from "./MainThietBi.vue?vue&type=script&lang=js"
export * from "./MainThietBi.vue?vue&type=script&lang=js"

import "./MainThietBi.vue?vue&type=style&index=0&id=42d07a90&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d07a90"]])

export default __exports__